import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { PublicClientApplication, EventType } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { GoogleOAuthProvider } from "@react-oauth/google";
const clientId = `623155047831-5kul72s5ij92bo0ht3r9q8b6rk9330k0.apps.googleusercontent.com`;




const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
 <GoogleOAuthProvider  clientId={clientId}>
    <App />
  </GoogleOAuthProvider > 
)

reportWebVitals()
